import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "apt-trade-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "실거래가 조회"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "국토교통부 신고 기준 서울시 아파트 매매 실거래가를 조건별로 검색합니다")
], -1)
const _hoisted_3 = { class: "filter-grid" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "sggCd" }, "자치구", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "전체", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "filter-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "umdNm" }, "법정동", -1)
const _hoisted_10 = { class: "filter-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "aptNm" }, "아파트명", -1)
const _hoisted_12 = { class: "filter-item filter-date" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "계약일", -1)
const _hoisted_14 = { class: "date-range" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "tilde" }, "~", -1)
const _hoisted_16 = { class: "advanced-filters" }
const _hoisted_17 = { class: "filter-grid" }
const _hoisted_18 = { class: "filter-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "거래금액 (만원)", -1)
const _hoisted_20 = { class: "range-pair" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "tilde" }, "~", -1)
const _hoisted_22 = { class: "filter-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "전용면적 (㎡)", -1)
const _hoisted_24 = { class: "range-pair" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "tilde" }, "~", -1)
const _hoisted_26 = { class: "filter-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "aptDong" }, "아파트 동", -1)
const _hoisted_28 = { class: "filter-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "floor" }, "층수", -1)
const _hoisted_30 = { class: "filter-item" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "cdealType" }, "거래 상태", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "전체", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "O" }, "해제된 거래", -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "filter-actions" }
const _hoisted_36 = { class: "action-btns" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn-search"
}, "조회", -1)
const _hoisted_38 = { class: "trade-result" }
const _hoisted_39 = { class: "result-head" }
const _hoisted_40 = { class: "result-count" }
const _hoisted_41 = {
  key: 0,
  class: "result-page"
}
const _hoisted_42 = { class: "table-scroll" }
const _hoisted_43 = { id: "contents-area" }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"row header desktop-only\"><div class=\"cell\">계약일</div><div class=\"cell\">위치</div><div class=\"cell\">아파트</div><div class=\"cell\">층</div><div class=\"cell\">전용면적</div><div class=\"cell align-right\">거래금액</div><div class=\"cell\">상태</div><div class=\"cell\">관심</div></div>", 1)
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "cell cell-date" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "계약일", -1)
const _hoisted_48 = { class: "cell cell-loc" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "위치", -1)
const _hoisted_50 = { class: "loc-gu" }
const _hoisted_51 = { class: "loc-dong" }
const _hoisted_52 = { class: "cell cell-apt" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "아파트", -1)
const _hoisted_54 = { class: "apt-name" }
const _hoisted_55 = {
  key: 0,
  class: "apt-dong"
}
const _hoisted_56 = { class: "cell" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "층", -1)
const _hoisted_58 = { class: "cell cell-area" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "전용면적", -1)
const _hoisted_60 = { class: "pyeong" }
const _hoisted_61 = { class: "cell cell-amount align-right" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "거래금액", -1)
const _hoisted_63 = { class: "amount" }
const _hoisted_64 = { class: "cell cell-status" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "상태", -1)
const _hoisted_66 = {
  key: 0,
  class: "status-tag cancel"
}
const _hoisted_67 = {
  key: 1,
  class: "status-tag normal"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "관심", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("button", {
  class: "favorite-btn",
  title: "관심 아파트 추가"
}, "☆", -1)
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { id: "empty" }, null, -1)
const _hoisted_74 = { class: "trade-modal-header" }
const _hoisted_75 = { class: "trade-modal-body" }
const _hoisted_76 = {
  key: 0,
  class: "modal-loading"
}
const _hoisted_77 = {
  key: 1,
  class: "modal-empty"
}
const _hoisted_78 = {
  key: 2,
  class: "modal-trade-list"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "modal-trade-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "계약일"),
  /*#__PURE__*/_createElementVNode("span", null, "동"),
  /*#__PURE__*/_createElementVNode("span", null, "층"),
  /*#__PURE__*/_createElementVNode("span", null, "평수"),
  /*#__PURE__*/_createElementVNode("span", null, "거래금액"),
  /*#__PURE__*/_createElementVNode("span", null, "해지")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageNavigation = _resolveComponent("PageNavigation")!
  const _component_StickyNavigation = _resolveComponent("StickyNavigation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "trade-filter",
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickSearch && _ctx.onClickSearch(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            id: "sggCd",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sggCd) = $event))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guOptions, (name, code) => {
              return (_openBlock(), _createElementBlock("option", {
                key: code,
                value: code
              }, _toDisplayString(name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.sggCd]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "umdNm",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.umdNm) = $event)),
            placeholder: "예: 삼성동"
          }, null, 512), [
            [_vModelText, _ctx.umdNm]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "aptNm",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aptNm) = $event)),
            placeholder: "예: 래미안퍼스티지"
          }, null, 512), [
            [_vModelText, _ctx.aptNm]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dealDateFrom) = $event))
            }, null, 512), [
              [_vModelText, _ctx.dealDateFrom]
            ]),
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dealDateTo) = $event))
            }, null, 512), [
              [_vModelText, _ctx.dealDateTo]
            ])
          ])
        ])
      ]),
      _createVNode(_Transition, { name: "adv" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.minDealAmount) = $event)),
                    placeholder: "최소 80000"
                  }, null, 512), [
                    [_vModelText, _ctx.minDealAmount]
                  ]),
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.maxDealAmount) = $event)),
                    placeholder: "최대 120000"
                  }, null, 512), [
                    [_vModelText, _ctx.maxDealAmount]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.minExcluUseAr) = $event)),
                    placeholder: "최소 45"
                  }, null, 512), [
                    [_vModelText, _ctx.minExcluUseAr]
                  ]),
                  _hoisted_25,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.maxExcluUseAr) = $event)),
                    placeholder: "최대 128"
                  }, null, 512), [
                    [_vModelText, _ctx.maxExcluUseAr]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "aptDong",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.aptDong) = $event)),
                  placeholder: "예: 101동"
                }, null, 512), [
                  [_vModelText, _ctx.aptDong]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "floor",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.floor) = $event)),
                  placeholder: "예: 15"
                }, null, 512), [
                  [_vModelText, _ctx.floor]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _withDirectives(_createElementVNode("select", {
                  id: "cdealType",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cdealType) = $event))
                }, _hoisted_34, 512), [
                  [_vModelSelect, _ctx.cdealType]
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.showAdvanced]
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("button", {
          type: "button",
          class: "adv-toggle",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAdvanced = !_ctx.showAdvanced))
        }, [
          _createTextVNode(" 상세 필터 "),
          _createElementVNode("span", {
            class: _normalizeClass(["chev", { open: _ctx.showAdvanced }])
          }, "▾", 2)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-reset",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onClickReset && _ctx.onClickReset(...args)))
          }, "초기화"),
          _hoisted_37
        ])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          (_ctx.pagination.totalElements > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" 총 "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.pagination.totalElements.toLocaleString()), 1),
                _createTextVNode("건 ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("검색 결과")
              ], 64))
        ]),
        (_ctx.pagination.totalElements > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.pagination.pageNumber + 1) + " / " + _toDisplayString(_ctx.pagination.totalPages) + " 페이지 ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "row data-row",
              onClick: ($event: any) => (_ctx.openDetailModal(item))
            }, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createTextVNode(" " + _toDisplayString(item.dealYear) + "." + _toDisplayString(_ctx.pad(item.dealMonth)) + "." + _toDisplayString(_ctx.pad(item.dealDay)), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.getGuName(item.sggCd)), 1),
                _createElementVNode("span", _hoisted_51, _toDisplayString(item.umdNm), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("span", _hoisted_54, _toDisplayString(item.aptNm), 1),
                (item.aptDong)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(item.aptDong), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createTextVNode(_toDisplayString(item.floor) + "층 ", 1)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createTextVNode(" " + _toDisplayString(item.excluUseAr) + "㎡ ", 1),
                _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.toPyeong(item.excluUseAr)) + "평", 1)
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.toEok(item.dealAmount)) + "억", 1)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                (item.cdealType === 'O')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "해제"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_67, "정상"))
              ]),
              _createElementVNode("div", {
                class: "cell favorite-cell",
                onClick: _withModifiers(($event: any) => (_ctx.onClickFavorite(item)), ["stop"])
              }, _hoisted_71, 8, _hoisted_68)
            ], 8, _hoisted_45))
          }), 128)),
          (_ctx.contents.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, " 조건에 맞는 실거래 내역이 없습니다. "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_73,
    _createVNode(_component_StickyNavigation, {
      parentSelector: "#apt-trade-wrapper",
      class: "sticky-navigation"
    }, {
      default: _withCtx(() => [
        (_ctx.pagination.totalElements > 0)
          ? (_openBlock(), _createBlock(_component_PageNavigation, {
              key: 0,
              "page-number": _ctx.pagination.pageNumber,
              "total-pages": _ctx.pagination.totalPages,
              "onUpdate:page": _ctx.handlePageChange
            }, null, 8, ["page-number", "total-pages", "onUpdate:page"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "trade-modal-overlay",
          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createElementVNode("div", {
            class: "trade-modal",
            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.modalAptNm) + " - 거래 이력", 1),
              _createElementVNode("button", {
                class: "modal-close-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_75, [
              (_ctx.modalLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, "불러오는 중..."))
                : (_ctx.modalTrades.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, "거래 이력이 없습니다."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _hoisted_79,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalTrades, (t, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "modal-trade-row"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(t.dealYear) + "." + _toDisplayString(t.dealMonth) + "." + _toDisplayString(t.dealDay), 1),
                          _createElementVNode("span", null, _toDisplayString(t.aptDong || '-'), 1),
                          _createElementVNode("span", null, _toDisplayString(t.floor) + "층", 1),
                          _createElementVNode("span", null, _toDisplayString(t.excluUseAr) + "평", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.toEok(t.dealAmount)) + "억", 1),
                          _createElementVNode("span", {
                            class: _normalizeClass({ 'cancel-tag': t.cdealType === 'O' })
                          }, _toDisplayString(t.cdealType === 'O' ? '해지' : ''), 3)
                        ]))
                      }), 128))
                    ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}